module.exports = __webpack_public_path__ + "img/preimush-img-3.1eecf096.png";